import type { FeatureCollection, Polygon } from 'geojson';
import { ApiModule } from '@core';
import { type Crop } from '@shared';
import type { ExpertAdvice, ExpertAdviceItem } from '../models';

export class ExpertAdviceApi extends ApiModule {
  protected endpoint = '/maximap/advice';

  public getExpertAdviceList(filters: any) {
    return this.api.get<ExpertAdviceItem[]>(`${this.endpoint}`, { params: { ...filters } });
  }

  public getExpertAdvice(id: string) {
    return this.api.get<FeatureCollection<Polygon, ExpertAdvice>>(`${this.endpoint}/${id}`);
  }

  public downloadExpertAdvicePdfs(ids: string[]) {
    return this.api.get<Blob>(`${this.endpoint}/pdf`, {
      params: { ids },
      responseType: 'blob'
    });
  }

  public loadCrop() {
    return this.api.get<Crop[]>(`/proplanta/plant`);
  }
}
